import React, {useCallback} from 'react'
import {ErrorMessage, FormikErrors} from 'formik'
import Select, {Props as SelectProps} from 'react-select'
import {maxHeaderSize} from 'http'
import {OverlayViewF} from '@react-google-maps/api'
import {Form, Select as SelectAntd} from 'antd'
import {Rule} from 'antd/es/form'
interface OptionType {
  value: string
  label: string
}
interface Props extends SelectProps<OptionType> {
  containerClassName?: string
  label?: string
  name: string
  type?: string
  placeholder?: string
  onChange?: any
  className?: string
  errors: FormikErrors<any>
  touched: any
  labelClassName?: string
  required?: boolean
  disabled?: boolean
  multiple?: boolean
  options: {label: string; value: string}[] | undefined
  values?: any
  style?: any
  setFieldValue: any
  arrValue?: string
  defaultValue?: any
  isClearable?: any
}

const FormSelect = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    className,
    errors,
    touched,
    labelClassName,
    required,
    options,
    placeholder,
    disabled,
    values,
    setFieldValue,
    multiple,
    arrValue,
    style,
    onChange,
    defaultValue,
    isClearable,

    ...rest
  } = props

  const selectStyles = {
    menuList: (styles: any) => {
      return {
        ...styles,
        maxHeight: 155,
      }
    },

    valueContainer: (styles: any, state: any) => {
      return {
        ...styles,
        height: 'auto',
        maxHeight: 100,
        overflow: 'auto',
        paddingLeft: /* multiple ? 16 : */ 16,
        paddingRight: 5,
        gap: 4,
      }
    },
  }

  const handleMultiSelectChange = useCallback(
    (option) => {
      let selectIds = option?.map((item: any) => item?.value)
      setFieldValue(name, selectIds)
      onChange && onChange(option)
    },
    [setFieldValue, name]
  )

  return (
    <div className={label ? 'row mb-6' : 'col-lg-6 '}>
      {label && (
        <label className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          <span className={required ? 'required' : ''}>{label}</span>
        </label>
      )}
      <div className={containerClassName ?? 'col-lg-6 '} data-cy={`${name}-checkbox-field`}>
        {multiple ? (
          <Select
            {...rest}
            id='color'
            className='customSelect'
            classNamePrefix='cusom-react-select'
            menuPlacement='bottom'
          
            styles={{
              ...selectStyles,
              control: (provided, state) => ({
                ...provided,
                // backgroundColor: disabled ? '#ffc700' : 'white',
                color: 'black',
                border: state.isFocused ? '1px solid #ddd' : '1px solid #ccc',
                boxShadow: state.isFocused ? '0 0 0 1px #ddd' : 'none',
                minHeight: '48px',
              }),
              valueContainer: (provided) => ({
                ...provided,
                padding: '0 8px',
              }),
            }}
            name={name}
            options={options}
            onChange={handleMultiSelectChange}
            value={options?.filter((obj) => values?.[name]?.includes(obj?.value))}
            isMulti={multiple}
            isDisabled={disabled}
            defaultValue={defaultValue}
            data-cy={`${name}-checkbox-field`}
            
          />
        ) : (
          <Select
            {...rest}
            id='color'
            className='customSelect'
            classNamePrefix='cusom-react-select'

            menuPlacement='bottom'
            styles={{
              ...selectStyles,
              control: (provided, state) => ({
                ...provided,
                // backgroundColor: disabled ? '#ffc700' : 'white',
                color: 'black',
                border: state.isFocused ? '1px solid #ddd' : '1px solid #ccc',
                boxShadow: state.isFocused ? '0 0 0 1px #ddd' : 'none',
                minHeight: '46.2px',
              }),
              valueContainer: (provided) => ({
                ...provided,
                padding: '0 8px',
              }),
            }}
            name={name}
            isClearable={isClearable}
            options={options}
            isDisabled={disabled}
            onChange={(option: any) => {
              if (option?.isReset) {
                setFieldValue(option?.resetValue, '')
              }
              setFieldValue(name, option?.value)
            }}
            value={
              arrValue || values?.[name]
                ? options?.find((obj) => obj?.value === (arrValue ? arrValue : values?.[name]))
                : null
            }
            defaultValue={defaultValue}
            data-cy={`${name}-checkbox-field`}
          />
        )}
        <div className='fv-plugins-message-container text-danger fw-bolder small text-start mt-1'>
          <ErrorMessage name={name} component='div' className='field-error-message' />
        </div>
      </div>
    </div>
  )
})

export default FormSelect

interface IPropsForm {
  name: string
  label: string
  placeholder: string
  rules: Rule[] | undefined
  options: {
    label: string
    value: string
  }[]
}
export const FormSelectAntd = ({name, label, placeholder, rules, options}: IPropsForm) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <SelectAntd placeholder={placeholder} allowClear showSearch options={options} />
    </Form.Item>
  )
}
